import jsonpPromise from 'jsonp-promise';
import qs from './query-string-util';
import * as constants from '@src/constants';

/**
 * jsonp-promise 增强
 * @param url
 * @param params
 */
const jsonp = (url, params = {}) => {
  // 使用 __ts__ 确保请求不会被各种原因缓存
  params = Object.assign({}, params, { __ts__: +new Date() });
  return jsonpPromise(url + '?' + qs.stringify(params), {
    prefix: '__zt',
    // 保证在 mock 开启时不超时
    timeout: DEPLOY_ENV !== 'master' && constants.IS_MOCK_ON ? 9999999 : undefined
  }).promise;
};

export default jsonp;



// WEBPACK FOOTER //
// ./src/utils/jsonp-util.js